'use client';
import React, { useState, useEffect } from 'react';
import AppLogo from '@/components/ui/AppLogo';

const Header: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 w-full z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-plum-deep/90 backdrop-blur-md border-b border-silver-lavender/10' :'bg-transparent'
      }`}
    >
      <div className="beam-border-h" />
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <AppLogo
          text="Velocity Trucking LLC"
          iconName="TruckIcon"
          size={32}
          className="text-cream"
        />

        <nav className="hidden md:flex items-center gap-8 text-[11px] font-bold uppercase tracking-widest text-silver-lavender/70">
          <a href="#rankings" className="hover:text-cream transition-colors">Programs</a>
          <a href="#pay-table" className="hover:text-cream transition-colors">Pay & Deductions</a>
          <a href="#home-time" className="hover:text-cream transition-colors">OTR & Regional</a>
          <a href="#cta-section" className="hover:text-cream transition-colors">Apply</a>
        </nav>

        <a
          href="#cta-section"
          className="bg-violet text-cream px-5 py-2.5 text-[11px] font-bold uppercase tracking-widest rounded-full hover:bg-violet-bright transition-all duration-300 cta-glow"
        >
          Apply Now
        </a>
      </div>
    </header>
  );
};

export default Header;